// src/context/CurrencyContext.js
import React, { createContext, useState, useEffect } from "react";

export const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const [selectedCurrency, setSelectedCurrency] = useState("1035987"); // Default: USD

   const siteItemIdToCurrencyCode = {
    "1035987": "USD",
    // "1227501": "SGD",
    "1113842": "INR",
  };

  const currencyCode = siteItemIdToCurrencyCode[selectedCurrency];

  useEffect(() => {
    const savedCurrency = localStorage.getItem("selectedCurrency");
    if (savedCurrency) {
      setSelectedCurrency(savedCurrency);

      if (window.OVExplore10) {
        window.OVExplore10.preferences.siteItemId = savedCurrency;
        if (typeof window.initializeOdySearchForm === "function") {
          window.initializeOdySearchForm(window.OVExplore10);
          console.log("Search form reinitialized with saved currency.");
        }
      }
    }
  }, [selectedCurrency]);

//   const changeCurrency = (newCurrency) => {
//     setSelectedCurrency(newCurrency);
//     localStorage.setItem("selectedCurrency", newCurrency);

//     if (window.OVExplore10) {
//       window.OVExplore10.preferences.siteItemId = newCurrency;
//       if (typeof window.initializeOdySearchForm === "function") {
//         window.initializeOdySearchForm(window.OVExplore10);
//         console.log("Search form reinitialized with new currency.");
//       }
//     }
//   };

  return (
    <CurrencyContext.Provider value={{selectedCurrency, setSelectedCurrency, currencyCode }}>
      {children}
    </CurrencyContext.Provider>
  );
};
